import { useWindowSize } from "shared/hooks/resize";

import LmfLoading from "shared/assets/images/lmf/lmf.gif";

const Loading = () => {
  const [height] = useWindowSize();
  return (
    <div className="loader__lmf" style={{ height: "90vh" }}>
      <img src={LmfLoading} alt="" />
    </div>
  );
};

Loading.propTypes = {};

Loading.defaultProps = {};

export default Loading;
